import classnames from 'classnames'
import { useChartLayoutGlobalModelAsync } from 'finviz-charts/app/utils/useChartLayoutGlobalModelAsync'

import { QuoteRoutes, SpecificChartFunctionality } from '../../../main/constants'
import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-short-interest-link a')

export default function ShortInterestLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  const { chartLayoutModel } = useChartLayoutGlobalModelAsync()
  const isQuoteFinancials = chartLayoutModel?.specificChartFunctionality === SpecificChartFunctionality.quoteFinancials
  const isQuoteOrQuoteFinancials =
    isQuoteFinancials || chartLayoutModel?.specificChartFunctionality === SpecificChartFunctionality.quotePage

  if (!currentTimeframePath || !isQuoteOrQuoteFinancials)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Short Interest
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.set(StatsQuery.ChartType, QuoteRoutes.ShortInterest)

  return (
    <a
      href={`${newURL.pathname}${newURL.search}`}
      className={classnames('tab-link', { 'font-semibold': isQuoteFinancials })}
    >
      Short Interest
    </a>
  )
}
